import {
  Users,
  Building2,
  Tag,
  FileText,
  Calendar,
  Mail,
  Newspaper,
  Settings,
  UserPlus,
  FolderOpen,
  Briefcase,
  Cog,
  BarChart3,
  Shield,
  BookOpen,
  LineChart,
  Landmark,
  RefreshCw,
  Inbox,
  Download,
  LucideIcon,
} from 'lucide-react';

interface NavigationItem {
  id: string;
  label: string;
  icon: LucideIcon;
  path?: string;
  description?: string;
  badge?: number | string;
}

interface NavigationGroup {
  id: string;
  label: string;
  icon: LucideIcon;
  items: NavigationItem[];
}

export const adminNavigation: NavigationGroup[] = [
  {
    id: 'user-management',
    label: 'User Management',
    icon: UserPlus,
    items: [
      {
        id: 'users',
        label: 'Users & Roles',
        icon: Users,
        path: '/admin/users',
        description: 'Manage user accounts and role assignments',
      },
      {
        id: 'portal-roles',
        label: 'Portal Roles',
        icon: Shield,
        path: '/admin/portal-roles',
        description: 'Manage investor portal roles and module access',
      },
    ],
  },
  {
    id: 'content-management',
    label: 'Content Management',
    icon: FolderOpen,
    items: [
      {
        id: 'tags',
        label: 'Document Tags',
        icon: Tag,
        path: '/admin/tags',
        description: 'Manage document categorization tags',
      },
      {
        id: 'financial-metrics',
        label: 'Financial Metrics',
        icon: BarChart3,
        path: '/admin/financial-metrics',
        description: 'Manage custom financial metrics for portfolio companies',
      },
      {
        id: 'templates',
        label: 'Templates',
        icon: FileText,
        path: '/admin/templates',
        description: 'Email and document templates',
      },
    ],
  },
  {
    id: 'fund-operations',
    label: 'Fund Operations',
    icon: Briefcase,
    items: [
      {
        id: 'funds',
        label: 'Fund Management',
        icon: Building2,
        path: '/admin/funds',
        description: 'Configure funds and bank accounts',
      },
      {
        id: 'chart-of-accounts',
        label: 'Chart of Accounts',
        icon: BookOpen,
        path: '/admin/chart-of-accounts',
        description: 'Manage ledger account definitions',
      },
      {
        id: 'bank-codes',
        label: 'Bank Codes',
        icon: Landmark,
        path: '/admin/bank-codes',
        description: 'Manage IBAN bank code to BIC and bank name mappings',
      },
      {
        id: 'fx-rates',
        label: 'FX Rates',
        icon: LineChart,
        path: '/admin/fx-rates',
        description: 'Manage organization-wide reference FX rates',
      },
      {
        id: 'ponto-bank-sync',
        label: 'Bank Sync (Ponto)',
        icon: RefreshCw,
        path: '/admin/ponto',
        description: 'Sync bank accounts and transactions from Ponto Connect',
      },
      {
        id: 'bank-incoming',
        label: 'Incoming Transactions',
        icon: Inbox,
        path: '/admin/bank-incoming',
        description: 'Staged bank lines awaiting a match to a fund transaction',
      },
    ],
  },
  {
    id: 'system-administration',
    label: 'System Administration',
    icon: Cog,
    items: [
      {
        id: 'scheduler',
        label: 'Job Scheduler',
        icon: Calendar,
        path: '/admin/scheduler',
        description: 'Manage scheduled jobs and tasks',
      },
      {
        id: 'email-queue',
        label: 'Email Queue',
        icon: Mail,
        path: '/admin/email-queue',
        description: 'Monitor and manage outgoing emails',
      },
      {
        id: 'investor-exports',
        label: 'Investor Exports',
        icon: Download,
        path: '/admin/investor-exports',
        description: 'Log of investor data exports',
      },
      {
        id: 'news',
        label: 'News Sources',
        icon: Newspaper,
        path: '/admin/news',
        description: 'Configure news and data sources',
      },
      {
        id: 'settings',
        label: 'System Settings',
        icon: Settings,
        path: '/admin/settings',
        description: 'Global system configuration',
      },
    ],
  },
];
